import { lazy } from "react"

export const EmployeeSalary = lazy(() => import("./employeeSalary/EmployeeSalary"))
export const TraineeSalary = lazy(() => import("./traineeSalary/TraineeSalary"))
export const Payslip = lazy(() => import("./payslip/Payslip"))
export const GenerateSalary = lazy(() => import("./employeeSalary/employeeSalaryPage/GenerateSalary"))
export const HoldSalary = lazy(() => import("./holdSalary/HoldSalary"))
export const Certificate = lazy(() => import("./certificate/Certificate"))